import { LoadingButton as MuiLoadingButton, LoadingButtonProps } from "@mui/lab";
import { MouseEvent } from "react";
import { useNavigate } from "react-router-dom";

const EXTERNAL_URL_PATTERN = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;

const isInternalHref = (href: string) => !EXTERNAL_URL_PATTERN.test(href);

type AppLoadingButtonProps = LoadingButtonProps & {
    href?: string;
    target?: string;
};

export default function LoadingButton(props: AppLoadingButtonProps) {
    const navigate = useNavigate();
    const { href, onClick, target, ...other } = props;
    const MUIButton = MuiLoadingButton as any;

    const shouldUseClientRouting =
        typeof href === "string" && isInternalHref(href) && (!target || target === "_self");

    const handleClick = (event: MouseEvent<any>) => {
        onClick?.(event);
        if (
            !shouldUseClientRouting ||
            event.defaultPrevented ||
            event.button !== 0 ||
            event.metaKey ||
            event.altKey ||
            event.ctrlKey ||
            event.shiftKey
        ) {
            return;
        }
        event.preventDefault();
        navigate(href);
    };

    return <MUIButton {...other} href={href} target={target} onClick={handleClick} />;
}
